// extracted by mini-css-extract-plugin
export default {"searchInput":"InputForm_searchInput__6q6Wo","submitButton":"InputForm_submitButton__ObGF9"};